// categoriesData.js
const categoriesData = [
    {
      id: "nouveautes",
      name: "Nouveautés",
      image: "https://zupimages.net/up/25/06/zu3p.png"
    },
    {
      id: "box-office",
      name: "Box-Office",
      image: "https://zupimages.net/up/25/06/xvh2.png"
    },
    {
      id: "gala",
      name: "Gala & Cérémonies",
      image: "https://zupimages.net/up/25/06/h31v.png"
    },
    {
      id: "acteurs-etoiles",
      name: "Acteurs étoiles",
      image: "https://zupimages.net/up/25/06/xn04.png"
    },
    {
      id: "autre",
      name: "Autre",
      image: "https://zupimages.net/up/25/06/j3jw.png"
    },
    {
      id: "action",
      name: "Action",
      image: "https://zupimages.net/up/25/06/l3b3.png"
    },
    {
      id: "aventure",
      name: "Aventure",
      image: "https://zupimages.net/up/25/06/jc7a.png"
    },
    {
      id: "animation",
      name: "Animation",
      image: "https://zupimages.net/up/25/06/ic5x.png"
    },
    {
      id: "biographie",
      name: "Biographie",
      image: "https://zupimages.net/up/25/06/ewui.png"
    },
    {
      id: "comedy",
      name: "Comédie",
      image: "https://zupimages.net/up/25/06/qrgp.png"
    },
    {
      id: "crime",
      name: "Crime",
      image: "https://zupimages.net/up/25/06/menq.png"
    },
    {
      id: "documentaire",
      name: "Documentaire",
      image: "https://zupimages.net/up/25/06/v0jj.png"
    },
    {
      id: "drama",
      name: "Drama",
      image: "https://zupimages.net/up/25/06/xsct.png"
    },
    {
      id: "fantasy",
      name: "Fantastique",
      image: "https://zupimages.net/up/25/06/obip.png"
    },
    {
      id: "guerre",
      name: "Guerre",
      image: "https://zupimages.net/up/25/06/5jhb.png"
    },
    {
      id: "histoire",
      name: "Histoire",
      image: "https://zupimages.net/up/25/06/2s2k.png"
    },
    {
      id: "horreur",
      name: "Horreur",
      image: "https://zupimages.net/up/25/06/bwnx.png"
    },
    {
      id: "musique",
      name: "Musique",
      image: "https://zupimages.net/up/25/06/t2j1.png"
    },
    {
      id: "mystere",
      name: "Mystère",
      image: "https://zupimages.net/up/25/06/4fgh.png"
    },
    {
      id: "romance",
      name: "Romance",
      image: "https://zupimages.net/up/25/06/nonc.png"
    },
    {
      id: "science-fiction",
      name: "Science-Fiction",
      image: "https://zupimages.net/up/25/06/40fh.png"
    },
    {
      id: "telefilm",
      name: "Téléfilm",
      image: "https://zupimages.net/up/25/06/1flf.png"
    },
    {
      id: "thriller",
      name: "Thriller",
      image: "https://zupimages.net/up/25/06/d8pj.png"
    },
    {
      id: "western",
      name: "Western",
      image: "https://zupimages.net/up/25/06/rtz1.png"
    }
  ];
  
  export default categoriesData;
  